import classNames from 'classnames';
import { ResortWeatherRow, ResortWeatherRowHeader } from 'components/resort/ResortWeatherRow';
import { IWeatherInfo, ResortWeatherLocation } from 'api/resort/types';
import { MeteoLogo } from 'components/resort/ResortWeather/MeteoLogo';
import styles from 'components/resort/ResortWeather/styles.module.scss';
import { AutoScroll } from 'components/blocks/AutoScroll';
import { useOTSTranslation } from 'i18n/useOTSTranslation';

export const Daily = (
  { weatherDaily, weatherLocation }: { weatherDaily: IWeatherInfo, weatherLocation: ResortWeatherLocation },
) => {
  const { t } = useOTSTranslation('common');

  return (
    <AutoScroll>
      <div className={classNames(styles.autoScroll, styles.visible)}>
        <section className={classNames(styles.box)}>
          <table>
            <caption style={{ display: 'none' }}>
              {t('common.dailyWeatherForecast')}
            </caption>
            <ResortWeatherRowHeader base={weatherDaily.base as number} summit={weatherDaily.summit as number} />
            <tbody>
              {weatherDaily.weatherItems.map((item, index) => (
                <ResortWeatherRow
                  key={item.datetime}
                  weatherItem={item}
                  weatherLocation={weatherLocation}
                  className={index % 2 ? '' : styles.other}
                />
              ))}
            </tbody>
          </table>
          <MeteoLogo logo={weatherDaily.weatherLogo} className={styles.logo} />
        </section>
      </div>
    </AutoScroll>
  );
};
